import { generatedApi } from './generated-api';
import { authEndpoints } from './endpoints/auth/auth-endpoints';
import { dialogsEndpoints } from './endpoints/dialogs/dialogs-endpoints';
import { channelsEndpoints } from './endpoints/channels/channels-endpoints';
import { agentsEndpoints } from './endpoints/agents/agents-endpoints';
import { clientInfoEndpoints } from './endpoints/client-info/client-info-endpoints';
import { integrationsEndpoints } from './endpoints/integrations/integrations-endpoints';
import { knowledgeBaseEndpoints } from './endpoints/knowledge-base/knowledge-base-endpoints';
import { teamsEndpoints } from './endpoints/teams/teams-endpoints';
import { creditTransactionsApi } from './endpoints/credit/credit-endpoints';
import { agentTestEndpoints } from './endpoints/agent-test/agent-test-endpoints';
import { presetsEndpoints } from './endpoints/presets/presets-endpoints';
import { previewEndpoints } from './endpoints/preview/preview-endpoints';

export * from './generated-api';
export { dialogsListApi, useGetListDialogsDialogListPostQueryQuery } from './dialogs-list-api';
export {
  creditTransactionsApi,
  useGetCreditTransactionsListQuery,
} from './endpoints/credit/credit-endpoints';
export {
  useKnowledgeLinkAddKnowledgeLinkAddPostMutation,
  useKnowledgeLinkRelatedKnowledgeLinkRelatedPostMutation,
  useKnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPostMutation,
  useKnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePostMutation,
} from './endpoints/knowledge-base/knowledge-base-endpoints';

export const presetsApi = generatedApi.enhanceEndpoints({
  endpoints: presetsEndpoints,
});

export const previewApi = generatedApi.enhanceEndpoints({
  endpoints: previewEndpoints,
});

export const enhancedApi = generatedApi.enhanceEndpoints({
  endpoints: {
    ...agentsEndpoints,
    ...authEndpoints,
    ...dialogsEndpoints,
    ...channelsEndpoints,
    ...clientInfoEndpoints,
    ...integrationsEndpoints,
    ...knowledgeBaseEndpoints,
    ...teamsEndpoints,
    ...agentTestEndpoints,
  },
});
